import React from 'react'
import i18next from 'i18next'
import Select from 'react-select'
import axios from 'src/lib/axios'

const { t } = i18next

const selectStyles = {
  control: (styles, state) => {
    return {
      ...styles,
      backgroundColor: 'white',
      borderRadius: 'var(--bs-border-radius)',
      color: 'var(--bs-body-color)',
      border: 'var(--bs-border-width) solid var(--bs-border-color)',
      ...(state.selectProps.valid === false && { borderColor: 'var(--danger)' }),
      minHeight: '2rem',
      ...(state.selectProps.isDisabled === true && { backgroundColor: 'white' }),
    }
  },

  menu: styles => ({ ...styles, zIndex: 1000 }),
  menuPortal: styles => ({ ...styles, zIndex: 1000 }),
  valueContainer: styles => ({ ...styles, paddingTop: '0.1rem', paddingBottom: '0.1rem' }),
  clearIndicator: styles => ({ ...styles, paddingTop: 0, paddingBottom: 0 }),
  dropdownIndicator: styles => ({ ...styles, paddingTop: 0, paddingBottom: 0 }),
}

const selectTheme = theme => {
  return {
    ...theme,
    borderRadius: 'var(--bs-border-radius)',
    colors: {
      ...theme.colors,
      primary25: '#86b7fe',
      primary: '#86b7fe',
    },
  }
}

class CompetenceSelect extends React.Component {
  static defaultProps = {
    styles: selectStyles,
    disabled: false,
    theme: selectTheme,
    selected: {},
    className: '',
    onChange: () => {},
  }

  state = {
    data: [],
  }

  async componentDidMount() {
    let data = await this.retrieveData()
    this.setState({ data })
  }

  handleChange = option => {
    this.props.onChange(option)
  }

  retrieveData = async () => {
    try {
      let response = await axios({
        url: `/api/sites/aree`,
      })
      return (response?.data?.aree ?? []).map(a => ({ value: a.id, label: a.name }))
    } catch (err) {
      console.error(err)
      return []
    }
  }

  render() {
    let { selected, disabled } = this.props
    return (
      <>
        <style jsx="true" global="true">{``}</style>
        <Select
          closeMenuOnSelect={false}
          name="area_competence"
          isMulti
          defaultValue={selected}
          placeholder={t('system_wide.competence_select', 'Area di competenza')}
          options={this.state.data}
          onChange={this.handleChange}
          isDisabled={disabled}
        />
      </>
    )
  }
}

export default CompetenceSelect
